/**
 * TODO: showButton
 */
import React, { lazy } from "react";
import RequestService from "../../utils/fetch";
import { getCookie, setCookie } from "../../utils/Cookies";
import translations from "../../translations/index";
const List = lazy(() => import("../List"));
const SkeletonFilter = lazy(() => import("../Skeleton/Filter"));
const SkeletonList = lazy(() => import("../Skeleton/List"));
const GeoSearch = lazy(() => import("../GeoSearch/index"));
const GeoSearchClass = lazy(() => import("../GeoSearch/index.class"));
const Filter = lazy(() => import("../Filter"));
const ConditionalWrapper = lazy(() => import("../../utils/ConditionalWrapper"));
const Pagination = lazy(() => import("../Pagination"));
const TmsErrorHandler = lazy(() => import("../TmsErrorHandler"));
const JobagentHint = lazy(() => import("../JobagentHint"));
class TmsJobList extends React.Component {
    filterChild = {};
    geoSearchComponent;
    constructor(props) {
        console.log(props);
        super(props);
        const configName = "myTalentionConfig";
        const config = window[configName];
        let errorMessage;
        if (!Object.keys(config).length) {
            errorMessage = {
                type: "error",
                code: "CONFIG_NOT_FOUND",
                description: "Config was not found.",
            };
        }
        this.filterChild = [];
        this.state = {
            // @ts-ignore
            translations: translations[config.lang] ? translations[config.lang] : translations["de"],
            preFilter: {},
            filterObject: {
                category: config.category || [],
            },
            configObject: config,
            paginationObject: {
                maxResults: config.pageSize || 10,
            },
            listOfCities: [],
            pageSizeValues: config.pageSizeValues || [5, 10, 25, 50],
            hasErrored: !Object.keys(config).length,
            errorMessage: false,
            totalJobs: 0,
            city: "",
            geosearchObject: {},
            isLoading: true,
            firstFetchDone: false,
            jobList: [],
            isFetching: true,
        };
        this.geoSearchComponent = React.createRef();
    }
    showFancyOverlay = (isComponentVisible) => {
        if (this.state.hasOwnProperty("showFancyOverlay")) {
            this.setState({
                showFancyOverlay: isComponentVisible
            }, () => {
                console.log(this.state.showFancyOverlay);
            });
        }
    };
    //
    componentDidMount() {
        (async () => {
            try {
                const { errorMessage } = this.state;
                const prefilterAttributes = this.getPrefilters();
                const prefilterAttributesGeo = await this.getPrefiltersGeo();
                // window.publicFilterChange = this.publicFilterChange.bind(this);
                this.handlePaginationClick = this.handlePaginationClick.bind(this);
                this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
                this.buildPagination = this.buildPagination.bind(this);
                this.handleFilterChange = this.handleFilterChange.bind(this);
                this.handleFilterRemove = this.handleFilterRemove.bind(this);
                this.handleGeoSearch = this.handleGeoSearch.bind(this);
                // this.handleListOfCities = this.handleListOfCities.bind(this);
                window.dispatchEvent(new Event("TmsJobListLoaded")); // is loaded
                if (this.state.configObject.fancyOptions) {
                    const { ...fancyOptions } = this.state.configObject.fancyOptions;
                    this.setState({
                        ...fancyOptions
                    });
                }
                if (!errorMessage) {
                    if (Object.keys(prefilterAttributes).length || Object.keys(prefilterAttributesGeo).length) {
                        this.setState({
                            preFilter: { ...this.state.preFilter, ...prefilterAttributes },
                            geosearchObject: prefilterAttributesGeo,
                            configObject: {
                                ...this.state.configObject,
                                category: prefilterAttributes.category ? prefilterAttributes.category : this.state.configObject.category
                            },
                            location: prefilterAttributesGeo,
                            filterObject: {
                                ...this.state.filterObject,
                                ...prefilterAttributes
                            },
                        }, () => {
                            this.handleAPICall("preFilter componentDidMount");
                        });
                    }
                    else {
                        //
                        let cookieFilterValues, cookieGeoFilterValues = {};
                        if (this.state.configObject.rememberFilterValues) {
                            const cookies = getCookie("tms-filter-values");
                            const cookiesGeo = getCookie("tms-filter-values-geo");
                            if (cookies || cookiesGeo) {
                                cookieFilterValues = cookies ? JSON.parse(cookies) : {};
                                if (this.state.configObject.geosearch) {
                                    const cookiesGeo = getCookie("tms-filter-values-geo") || {};
                                    if (Object.keys(cookiesGeo).length) {
                                        if (typeof cookiesGeo === "string") {
                                            cookieGeoFilterValues = JSON.parse(cookiesGeo) || {};
                                        }
                                    }
                                }
                                this.setState({
                                    preFilter: { ...cookieFilterValues },
                                    filterObject: {
                                        ...cookieFilterValues,
                                        ...this.state.filterObject,
                                    },
                                    geosearchObject: cookieGeoFilterValues
                                }, () => {
                                    this.handleAPICall("componentDidMount with cookies");
                                });
                            }
                            else {
                                /**
                                 *  cookie not found or empty
                                 **/
                                this.handleAPICall("componentDidMount without cookies");
                            }
                        }
                        else {
                            this.handleAPICall("componentDidMount without cookies");
                        }
                    }
                }
            }
            catch (e) {
                console.error(e);
            }
        })();
    }
    handleFilterChange = (name, values) => {
        const filter = [];
        filter[name] = [];
        for (let i = 0; i < values.length; i++) {
            const filterValue = values[i];
            filter[name].push(filterValue.value);
        }
        this.setState({
            isFetching: true,
            paginationObject: {
                ...this.state.paginationObject,
                offset: 0,
            },
            filterObject: {
                ...this.state.filterObject,
                ...filter
            },
        }, () => {
            this.handleAPICall("handleFilterChange");
        });
    };
    handleListOfCities = (list) => {
        this.setState({
            listOfCities: list
        });
        return;
    };
    handleCity = (city) => {
        this.setState({
            city: city
        });
    };
    handleGeoSearch = (value) => {
        this.setState({
            geosearchObject: value,
        }, () => {
            this.handleAPICall("geosearch");
        });
    };
    handlePaginationClick(value) {
        this.handlePaginationChange(value);
    }
    handlePaginationChange(newOffset) {
        const offset = newOffset - 1;
        this.setState({
            isFetching: true,
            paginationObject: {
                ...this.state.paginationObject,
                offset: offset * (this.state.configObject.pageSize || 10),
            },
        }, () => {
            this.handleAPICall("handlePaginationChange");
        });
    }
    buildPagination = (c, m) => {
        if (c < 1) {
            c = 1;
        }
        let rangeWithDots = [];
        if (this.state.configObject.paginationType === "hide-last") {
            const current = c;
            const last = m;
            const delta = 2;
            const left = current - delta;
            const right = current + delta + 1;
            const range = [];
            let l;
            for (let i = 1; i <= last; i++) {
                if (i >= left && i < right) {
                    range.push(i);
                }
            }
            for (const i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }
        }
        else {
            const current = c;
            const last = m;
            const delta = 2;
            const left = current - delta + 1;
            const right = current + delta + 1;
            const range = [];
            let l;
            for (let i = 1; i <= last; i++) {
                if (i === 1 || i === last || (i >= left && i < right)) {
                    range.push(i);
                }
            }
            for (const i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    }
                    else if (i - l !== 1) {
                        rangeWithDots.push("...");
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }
        }
        if (!rangeWithDots.length) {
            rangeWithDots = [1];
        }
        this.setState({ pagination: rangeWithDots });
    };
    handleAPICall(where) {
        // console.log(`handleAPICall called from: ${where}`);
        const { paginationObject, configObject, geosearchObject, preFilter, } = this.state;
        let { filterObject } = this.state;
        if (configObject.keepJobPrefilter) {
            filterObject = {
                ...preFilter,
                ...filterObject,
            };
        }
        if (configObject.rememberFilterValues) {
            const hasFilter = Object.keys(filterObject)
                .filter(item => {
                return item !== "category";
            });
            if (hasFilter.length) {
                setCookie("tms-filter-values", JSON.stringify(filterObject));
            }
            if (configObject.geosearch && Object.keys(geosearchObject).length) {
                setCookie("tms-filter-values-geo", JSON.stringify(geosearchObject));
            }
        }
        RequestService.postRequest(`${configObject.clientURL}talention/api/3.2/job`, {
            filter: filterObject,
            exactMatch: configObject.exactMatch || false,
            location: geosearchObject,
            pagination: {
                max: paginationObject.maxResults,
                offset: paginationObject.offset,
            },
            sorter: {
                sort: configObject.jobSorter || "createdDate",
                order: configObject.jobSorterOrder || "desc"
            }
        })
            .then((data) => {
            const jobListeError = {
                title: "error",
                description: data.error,
                id: "error",
                campaignProperties: {},
            };
            this.setState({
                isLoading: false,
                isFetching: false,
                jobList: data.error ? [jobListeError] : data.results,
                paginationObject: {
                    ...this.state.paginationObject,
                    resultsTotal: data.resultsTotal,
                    offset: data.offset,
                },
            }, () => {
                if (configObject.jumpToTopAfterFetch && this.state.firstFetchDone) {
                    const element = document.querySelector("#tms-joblist-wrap") || document.querySelector(configObject.jumpToTopAfterFetchID);
                    const scrollIntoViewOptions = configObject.jumpToTopAfterFetchOptions || {
                        behavior: "smooth",
                    };
                    element.scrollIntoView(scrollIntoViewOptions);
                }
                window.dispatchEvent(new Event("TmsJobListFeedChanged")); // when stat of joblsit has changed
                if (this.state.firstFetchDone) {
                    // LEGACY EVENT just filterchanged
                    window.dispatchEvent(new Event("TmsJobListChanged")); // when filter has changed // legacy!!!!!!
                    // LEGACY EVENT just filterchanged
                    // USE THIS
                    window.dispatchEvent(new Event("TmsJobFilterChanged")); // when filter has changed
                }
                else {
                    this.setState({
                        firstFetchDone: true
                    });
                }
            });
        });
    }
    getPrefiltersGeo = async () => {
        const prefilterGeoSearch = {};
        /**
         * We are looking for filter in the parameters
         */
        if (typeof google !== "object") {
            console.error("NO_GOOGLE_FOUND \n You tried to use a function that requires Google maps, but it was not found. Check your implementation or the key. Will ignore the Google maps functions like places autocomplete");
            return {};
        }
        let processPrefilter = true;
        if (this.props.attribute.prefilter) {
            processPrefilter = JSON.parse(this.props.attribute.prefilter.value);
        }
        if (window.location.search.indexOf("tms-") !== -1) {
            let search = window.location.search.replace("?", "")
                .split("&");
            search = search.filter((item) => {
                return item.indexOf("tms-") !== -1;
            });
            search = search.map((item) => {
                return item.replace(/tms-/g, "");
            });
            search.forEach((item) => {
                const key = item.split("=")[0];
                const value = item.split("=")[1];
                if (key.indexOf("geosearch-") !== -1 && value) {
                    if (key.indexOf("radius") !== -1 || key.indexOf("diameter") !== -1) {
                        prefilterGeoSearch["radius"] = parseInt(value.split(",")[0]);
                    }
                    else {
                        prefilterGeoSearch[key.replace("geosearch-", "")] = decodeURIComponent(value.split(",")[0]);
                    }
                }
            });
            /**
             * We are looking for filter in the attributes
             */
        }
        let output = {
            lat: null,
            lng: null
        };
        if (this.props.attribute.city && this.props.attribute.city.value) {
            prefilterGeoSearch.city = this.props.attribute.city.value;
        }
        if (this.props.attribute.radius && parseInt(this.props.attribute.radius.value)) {
            prefilterGeoSearch.radius = parseInt(this.props.attribute.radius.value);
        }
        if (Object.keys(prefilterGeoSearch).length && Object.hasOwn(prefilterGeoSearch, "city")) {
            const geocoder = new google.maps.Geocoder();
            await geocoder.geocode({
                address: decodeURIComponent(prefilterGeoSearch.city)
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    output["lat"] = results[0].geometry.location.lat();
                    output["lng"] = results[0].geometry.location.lng();
                }
            });
        }
        if (processPrefilter) {
            return { ...prefilterGeoSearch, ...output };
        }
        return {};
    };
    getPrefilters() {
        const prefilter = {};
        /**
         * We are looking for filter in the parameters
         * but check first if the no prefilter attribute ist present
         */
        let processPrefilter = true;
        if (this.props.attribute.prefilter) {
            processPrefilter = JSON.parse(this.props.attribute.prefilter.value);
        }
        if (window.location.search.indexOf("tms-") !== -1) {
            let search = window.location.search.replace("?", "")
                .split("&");
            search = search.filter((item) => {
                return item.indexOf("tms-") !== -1;
            });
            search = search.map((item) => {
                return item.replace(/tms-/g, "");
            });
            search.forEach((item) => {
                const key = item.split("=")[0];
                const value = decodeURIComponent(item.split("=")[1]);
                if (value) {
                    if (key.indexOf("geosearch-") === -1) {
                        prefilter[key] = value.split(",");
                    }
                }
                if (key.indexOf("page") !== -1) {
                    prefilter[key] = parseInt(value);
                    this.setState({
                        paginationObject: {
                            ...this.state.paginationObject,
                            offset: this.state.configObject.pageSize * (parseInt(value) - 1)
                        }
                    });
                }
            });
            /**
             * We are looking for filter in the attributes
             */
        }
        if (this.props.attribute) {
            // normale pre filtering
            if (this.props.attribute.filter && this.props.attribute.filter.value) {
                try {
                    const tagAttributes = JSON.parse(this.props.attribute.filter.value);
                    for (const tag in tagAttributes) {
                        if (prefilter[tag] === undefined) {
                            prefilter[tag] = [];
                        }
                        tagAttributes[tag].forEach((item) => {
                            if (prefilter[tag].indexOf(decodeURIComponent(item)) === -1) {
                                prefilter[tag].push(decodeURIComponent(item));
                            }
                        });
                    }
                }
                catch (e) {
                    console.error("Error while parsing pre filter attribute, object must be a valid json. Skipping pre filtering.");
                    console.error("Value was:", this.props.attribute.filter.value);
                }
            }
            // override category from config
            if (this.props.attribute.category) {
                const CategoryArray = JSON.parse(this.props.attribute.category.value);
                if (Array.isArray(CategoryArray)) {
                    prefilter["category"] = CategoryArray;
                }
            }
        }
        if (processPrefilter) {
            return prefilter;
        }
        // just return category
        return {
            category: prefilter.category || this.state.configObject.category
        };
    }
    handleFilterRemove = (filterName, filterValue) => {
        const { filterElement } = this.filterChild[filterName];
        if (filterElement !== undefined && typeof filterElement.current.handleRemove === "function") {
            filterElement.current.handleRemove({
                label: filterValue,
                value: filterValue
            });
        }
        const filter = this.state.filterObject[filterName];
        const index = filter.indexOf(filterValue);
        filter.splice(index, 1);
        this.setState({
            isFetching: true,
            filterObject: {
                ...this.state.filterObject,
                [filterName]: filter,
            },
        }, this.handleAPICall);
    };
    showSkeleton() {
        this.setState({
            isFetching: true,
            isLoading: true
        });
    }
    async handleFilterReset() {
        const { configObject } = this.state;
        // if (configObject.geosearch?.active && this.geoSearchComponent.current.filterElementInput.current !== null) {
        //     this.geoSearchComponent.current.resetGeoObject();
        // }
        const form = document.querySelector("#tms-filter-wrap");
        const inputs = form.querySelectorAll(".tms-filter--input");
        inputs.forEach((input) => {
            input.value = "";
        });
        let prefilter = {};
        let prefilterGeo = {};
        if (configObject.keepJobPrefilter) {
            prefilter = this.getPrefilters();
            prefilterGeo = await this.getPrefiltersGeo();
        }
        this.setState({
            filterTags: {},
            geosearchObject: prefilterGeo,
            paginationObject: {
                ...this.state.paginationObject,
                offset: 0,
            },
            jobList: [],
            city: "",
            listOfCities: [],
            firstFetchDone: false,
            filterObject: {
                ...prefilter,
                category: this.state.configObject.category || [],
            },
            isFetching: true,
        }, () => {
            for (const filter in this.filterChild) {
                const { current } = this.filterChild[filter].filterElement;
                if (typeof current.clearDropdown === "function") {
                    current.clearDropdown();
                }
                else {
                    this.filterChild[filter].resetValues();
                }
            }
            if (this.state.configObject.rememberFilterValues) {
                setCookie("tms-filter-values", JSON.stringify({}));
                if (this.state.configObject.geosearch.active) {
                    setCookie("tms-filter-values-geo", JSON.stringify({}));
                }
            }
            // Resete Pagination, otherwise the pagination would stuck on the page before the reset.
            this.buildPagination(1, this.state.paginationObject.resultsTotal);
            window.history.replaceState({}, document.title, location.href.split("?")[0]);
            this.handleAPICall("reset");
        });
    }
    handleFilterSubmit = () => {
        const form = document.querySelector("#tms-filter-wrap");
        const inputs = form.querySelectorAll(".tms-filter-item--input input");
        const payload = {};
        const filterKeys = Object.keys(this.filterChild);
        filterKeys.forEach((key) => {
            this.filterChild[key].setState({
                currentValue: ""
            });
        });
        const { filterObject } = this.state;
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            if (input.value) {
                // no double values
                if (filterObject[input.dataset.tmsName] && filterObject[input.dataset.tmsName].indexOf(input.value) !== -1) {
                    return true;
                }
                if (filterObject[input.dataset.tmsName] !== undefined) {
                    payload[input.dataset.tmsName] = filterObject[input.dataset.tmsName];
                    if (filterObject[input.dataset.tmsName].indexOf(input.value) === -1) {
                        payload[input.dataset.tmsName].push(input.value);
                    }
                }
                else {
                    payload[input.dataset.tmsName] = [input.value];
                }
                this.filterChild[input.dataset.tmsName].addToItems({
                    value: input.value,
                    label: input.value
                });
                this.filterChild[input.dataset.tmsName].filterElement.current.input.value = "";
            }
        }
        this.setState({
            isFetching: true,
            filterObject: {
                ...this.state.filterObject,
                ...payload,
            },
        }, () => {
            this.handleAPICall("handleFilterSubmit");
        });
    };
    handlePageSizeChange = (event) => {
        if (event.length) {
            const pageSize = parseInt(event[0].value);
            if (pageSize !== this.state.configObject.pageSize) {
                this.setState({
                    isFetching: true,
                    configObject: {
                        ...this.state.configObject,
                        pageSize,
                    },
                    paginationObject: {
                        ...this.state.paginationObject,
                        maxResults: pageSize,
                        max: pageSize,
                    },
                }, () => {
                    this.handleAPICall("handlePageSizeChange");
                });
            }
        }
    };
    createMarkup(html) {
        return { __html: html };
    }
    render() {
        const { jobList, isLoading, isFetching, hasErrored, pagination, errorMessage, preFilter, geosearchObject, paginationObject, configObject, translations, } = this.state;
        const { myFilter, hideFilter, jobListProperties, disableJobListPropertyWrap, disableJobListTitleWrap, disableButtonWrap, customMaxResultsText, disableFilterWrap, geosearch, } = configObject;
        /** sort filter **/
        if (myFilter !== undefined) {
            myFilter.sort((a, b) => {
                return a.order - b.order;
            });
        }
        const { resultsTotal, offset } = paginationObject;
        const GeoComponent = typeof geosearch?.version === "undefined" ? GeoSearchClass : GeoSearch;
        const FilterBasic = (React.createElement(ConditionalWrapper, { condition: !disableFilterWrap, wrapper: (children) => (React.createElement("div", { className: ["tms-filter-item-wrap"].join(" ") }, children)) },
            myFilter &&
                myFilter.map((filter) => (React.createElement(Filter
                // ref={filter.type === 'select' ? filterChild => this.filterChild[filter.name] = filterChild : false}
                , { 
                    // ref={filter.type === 'select' ? filterChild => this.filterChild[filter.name] = filterChild : false}
                    ref: filter.type === "select" || filter.type === "input" ? filterChild => this.filterChild[filter.name] = filterChild : null, preFilter: preFilter, config: configObject, showFancyOverlay: this.showFancyOverlay, translations: translations, handleFilterRemove: this.handleFilterRemove, handleFilterChange: this.handleFilterChange, key: filter.name, filter: filter }))),
            geosearch?.active && React.createElement(GeoComponent, { handleListOfCities: this.handleListOfCities, listOfCities: this.state.listOfCities, handleCity: this.handleCity, city: this.state.city, showFancyOverlay: this.showFancyOverlay, handleGeoSearch: this.handleGeoSearch, geosearchObject: geosearchObject, diameters: geosearch.diameters || [10, 25, 100, 250] })));
        if (hasErrored) {
            return React.createElement(TmsErrorHandler, { error: errorMessage });
        }
        if (isLoading) {
            // bit hacky. parse the dom element for page size and set page size from config as fallback.
            // we can match the count of the skeleton elements to the current page size
            const pageSizeSelect = document.querySelector("#tms-page-size");
            let pageSize = this.state.configObject.pageSize;
            if (pageSizeSelect !== null) {
                pageSize = parseInt(pageSizeSelect.options[pageSizeSelect.selectedIndex].value);
            }
            return (React.createElement(React.Fragment, null,
                hideFilter ? null : React.createElement(SkeletonFilter, { filter: 3 }),
                React.createElement(SkeletonList, { filter: 3, count: 3 })));
        }
        const MaxResultsTag = customMaxResultsText ? customMaxResultsText.tag || "h1" : "h1";
        return (React.createElement("div", { id: "tms-joblist-wrap" },
            this.state.showFancyOverlay ?
                React.createElement("div", { className: `tms-search-fancy-overlay ${this.state.showFancyOverlay ? "active" : ""}` })
                : null,
            !configObject.hideMaxResults && (React.createElement("section", { className: "joblist-maxresults" },
                React.createElement(MaxResultsTag, null,
                    customMaxResultsText.prepend && (React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--prepend", dangerouslySetInnerHTML: this.createMarkup(customMaxResultsText.prepend) })),
                    React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--hits" }, paginationObject.resultsTotal),
                    " ",
                    paginationObject.resultsTotal === 1 ? customMaxResultsText.single || translations.jobFoundSingle : customMaxResultsText.multiple || translations.jobFoundMultiple,
                    customMaxResultsText.append && (React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--append", dangerouslySetInnerHTML: this.createMarkup(customMaxResultsText.append) }))))),
            hideFilter ? null : myFilter && (React.createElement("div", { id: "tms-filter-wrap", className: "tms-filter-wrap" },
                FilterBasic,
                React.createElement(ConditionalWrapper, { condition: !disableButtonWrap, wrapper: (children) => (React.createElement("div", { className: ["tms-filter-button-wrap"].join(" ") }, children)) },
                    React.createElement("a", { className: [
                            "tms-filter-button",
                            "tms-filter-button--submit",
                        ].join(" "), onClick: () => {
                            this.handleFilterSubmit();
                        }, type: "submit" }, translations.search),
                    React.createElement("a", { className: [
                            "tms-filter-button",
                            "tms-filter-button--reset",
                        ].join(" "), onClick: async () => {
                            await this.handleFilterReset();
                        }, type: "reset" }, translations.reset)))),
            React.createElement(JobagentHint, { configObject: this.state.configObject, geosearchObject: this.state.geosearchObject, filterObject: this.state.filterObject, translation: this.state.translations }),
            isFetching ? React.createElement(SkeletonList, { filter: configObject.myFilter.length, count: configObject.pageSize }) :
                React.createElement(List, { attributes: configObject.link, parameter: configObject.parameterQuery, showJoblistButton: configObject.showJoblistButton, showJobListApplyButton: configObject.showJobListApplyButton, applyButtonText: configObject.applyButtonText, jobListButtonText: configObject.jobListButtonText, disableJoblistLink: configObject.disableJoblistLink, jobListProperties: jobListProperties, disableJobListTitleWrap: disableJobListTitleWrap, disableJobListPropertyWrap: disableJobListPropertyWrap, isFetching: isFetching, items: jobList }),
            !configObject.hidePagination && (React.createElement("div", { id: "tms-pagination-wrap", className: ["tms-pagination-wrap"].join(" ") },
                React.createElement(Pagination, { handlePageSizeChange: (e) => {
                        this.handlePageSizeChange(e);
                    }, pagination: pagination, buildPagination: this.buildPagination, paginationObject: paginationObject, showFancyOverlay: this.showFancyOverlay, config: configObject, pageSizeValues: [1, 2, 3, 4], handlePaginationClick: this.handlePaginationClick, number: Math.ceil(resultsTotal / configObject.pageSize), active: Math.ceil(offset / configObject.pageSize) })))));
    }
}
export default TmsJobList;
